import { Box, Button, Flex, FormLabel, Heading, Input, Table, Tbody, Td, Th, Thead, Tooltip, Tr, List, ListItem } from "@chakra-ui/react"
import { Layout } from "../../GlobalComponent/Layout/Layout"
import { useEffect, useState } from "react"
import { createBulkEmailJob, getAllEmailJobs } from "../../Http/Index"
import { CustomModal } from "../../GlobalComponent/CustomModal/CustomModal";
import { useNavigate } from "react-router-dom";
import { getCompanyList } from "../BenificiaryHavingNoHospital/action/getAllCompany";
import { InfoIcon } from "@chakra-ui/icons";

export interface AgentData {
    agentId: string;
    agentName: string;
}

export enum QueryType {
    Dynamic = "Dynamic",
    Custom = "Custom"
}
export enum QueryStatus {
    Inprogress = "Inprogress",
    Success = "Success",
    Failed = "Failed",
}

export interface Query {
    queryType: QueryType;
    query: {
        [key: string]: any; // In case there are more dynamic keys
    };
    failedPage: number;
    status: QueryStatus;
}

export enum JobStatus {
    New = "New",
    Pending = "Pending",
    Completed = "Completed",
    Inprogress = "Inprogress"
}

export interface EmailJobsInterface {
    _id: string;
    jobName: string;
    agentData: AgentData;
    templateId: string;
    templateName: string;
    jobStatus: JobStatus;
    send_to: "All";
    emailVars: {
        [key: string]: any; // In case there are more dynamic keys
    };
    filterQuery: Query[],
    createdAt: string;
    updatedAt: string;
}

export const EmailBulkMessage: React.FC = () => {
    const [allEmailJobs, setAllEmailJobs] = useState<EmailJobsInterface[] | []>([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [jobName, setJobName] = useState("")
    const [isJobCreationLoading, setIsJobCreationLoading] = useState(false)
    const [filteredCompany, setFilteredCompany] = useState<any[]>([])
    const [selectedCompany, setSelectedCompany] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [showOptions, setShowOptions] = useState<boolean>(false);
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            await getAllJobs()
            await getAllCompanyData();
        })();
    }, [])

    const getAllJobs = async () => {
        try {
            let allJobData = await getAllEmailJobs();
            setAllEmailJobs(allJobData.data)
        } catch (error) {
            console.log(error)
            alert("Technical Error while getting All Jobs")
        }
    }

    const getAllCompanyData = async () => {
        try {
            const getCompany = await getCompanyList();
            let filteredCompany = getCompany.data.filter((item: any) => item?.email);
            setFilteredCompany(filteredCompany);
        } catch (error) {
            console.log(error)
        }
    }

    const handleModal = () => {
        setIsModalOpen(!isModalOpen)
        setSearchTerm('')
        setShowOptions(false)
        setSelectedCompany(null)
    }

    const handleCompanySelect = (companyId: string, companyName: string) => {
        setSelectedCompany(companyId)
        setSearchTerm(companyName)
        setShowOptions(false)
    }

    const filteredCompanies = filteredCompany.filter(company =>
        company.companyName.toLowerCase().includes(searchTerm.toLowerCase())
    )

    const createJob = async () => {
        setIsJobCreationLoading(true)
        try {
            if (!jobName) {
                alert("Please provide job name")
                return
            }
            if (selectedCompany) {
                await createBulkEmailJob(jobName, { companyId: selectedCompany })
            } else {
                await createBulkEmailJob(jobName)

            }

            setIsJobCreationLoading(false)
            await getAllJobs()
            handleModal()
        } catch (error) {
            console.log(error)
            alert("Technical Error, Please Try Again")
            setIsJobCreationLoading(false)
        }
    }

    const openJobData = (jobId: string) => {
        navigate(`${jobId}`)
    }

    return (
        <Layout>
            <>
                <Heading size={"lg"} textAlign={"center"}>
                    Send Email
                </Heading>

                <Flex mt={"20px"} justifyContent={"center"}>
                    <Button colorScheme="green" onClick={handleModal}>Create Job</Button>
                    {isModalOpen && < CustomModal modalTitle="Create Job" handleCloseModal={handleModal}>
                        <Box textAlign={"left"} justifyContent={"left"} width={"100%"}>
                            <Input type="text" onChange={(e) => setJobName(e.target.value)} placeholder="Enter Job Name"></Input>
                            <Box mt={"20px"} mb={"20px"}>
                                <FormLabel>

                                    <Tooltip
                                        label="This company selection is optional, you can create a job without selecting a company. If you select a company, the job will be associated with that company and emails will be sent using the company's email credentials."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>

                                </FormLabel>
                                <Box position="relative" w="100%">
                                    <Input
                                        placeholder="Search Company"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onFocus={() => setShowOptions(true)}
                                        onBlur={() => setTimeout(() => setShowOptions(false), 200)}
                                    />
                                    {showOptions && filteredCompanies.length > 0 && (
                                        <List
                                            position="absolute"
                                            top="100%"
                                            left={0}
                                            right={0}
                                            bg="white"
                                            border="1px solid"
                                            borderColor="gray.200"
                                            borderRadius="md"
                                            maxH="200px"
                                            overflowY="auto"
                                            zIndex={10}
                                        >
                                            {filteredCompanies.map((company) => (
                                                <ListItem
                                                    key={company._id}
                                                    p={2}
                                                    cursor="pointer"
                                                    _hover={{ bg: "gray.100" }}
                                                    onClick={() => handleCompanySelect(company._id, company.companyName)}
                                                >
                                                    {company.companyName}
                                                </ListItem>
                                            ))}
                                        </List>
                                    )}
                                </Box>
                            </Box>
                            <Button colorScheme="green" mt={"20px"} onClick={createJob} isDisabled={isJobCreationLoading}>Create Job</Button>
                        </Box>
                    </CustomModal>}
                </Flex>

                <Table variant="unstyled" mt={"30px"}>
                    <Thead>
                        <Tr>
                            <Th>JOB NAME</Th>
                            <Th>AGENT</Th>
                            <Th>CREATED AT</Th>
                            <Th>UPDATED AT</Th>
                            <Th>STATUS</Th>
                        </Tr>
                    </Thead>
                    <Tbody >
                        {allEmailJobs.length > 0 &&
                            allEmailJobs.map((item) => {
                                return (
                                    <Tr onClick={(e) => openJobData(item._id)}>
                                        <Td>{item.jobName}</Td>
                                        <Td>{item.agentData.agentName}</Td>
                                        <Td>{item.createdAt}</Td>
                                        <Td>{item.updatedAt}</Td>
                                        <Td>{item.jobStatus}</Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </>
        </Layout >
    )
}